import { useAppDispatch } from 'app/store';
import React, { useEffect } from 'react';
import { setActionBtnTitle, setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { useParams } from 'react-router';
import { Box } from '@mui/system';
import { IRatingHistoryModel } from 'entities/competitions-b2cr';
import { DataTableFrontendPagination } from 'shared/ui/Table';
import {
  CompetitionSalesPointRatingStatsWidget,
  ICompetitionSalesPointRatingStatsWidgetFlow,
} from '../../../widgets/competitions-b2b/salePoint';
import {
  useGetAdminCompetitionItemParticipantQuery,
  useGetAdminCompetitionItemQuery,
  useGetAdminCompetitionItemRatingHistoryQuery,
} from '../../../entities/competitions-b2b';
import { fieldsBannerConfig } from '../../../widgets/competitions-b2b/salePoint/model';
import { ShortPresentationItem } from '../../../widgets/competitions-b2b/ShortPresentationItem';

const CompetitionSalePointDetails = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const id = parseInt(params.id || '');
  const ttId = parseInt(params.ttId || '');
  const { data: competitionData } = useGetAdminCompetitionItemQuery({ competition_id: id });
  const { data: participantData } = useGetAdminCompetitionItemParticipantQuery({
    competition_id: id,
    participant_id: ttId,
  });
  const { data } = useGetAdminCompetitionItemRatingHistoryQuery({ competitionId: id, participantId: ttId });

  useEffect(() => {
    dispatch(setHeaderTitle('Статистика соревнования по торговой точке'));
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Изменить'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '80%', mb: 3 }}>
          <ShortPresentationItem
            title="Название ТТ"
            value={participantData?.title || '---'}
          />
          <ShortPresentationItem
            title="Общая сумма покупок (рейтинг)"
            value={participantData?.purchase_amount_total.toString() || '0'}
          />
          {/* <ShortPresentationItem title='Текущее место' value={salePointData?.status || '---'} /> */}
        </Box>
        <Box sx={{ marginRight: 2 }}>
          {competitionData ? (
            <CompetitionSalesPointRatingStatsWidget
              participantId={ttId}
              competitionId={id}
              label="Статистика изменения места в рейтинге"
            />
          ) : null}
        </Box>
        {competitionData ? (
          <CompetitionSalesPointRatingStatsWidget
            flow={ICompetitionSalesPointRatingStatsWidgetFlow.purchases}
            participantId={ttId}
            competitionId={id}
            label="Статистика покупок"
          />
        ) : null}
      </Box>
      <DataTableFrontendPagination<IRatingHistoryModel>
        title="Таблица участников ТТ"
        data={data as IRatingHistoryModel[]}
        columnConfig={fieldsBannerConfig.map((field) => ({
          name: field.title,
          dataFieldName: field.field as any,
          width: field.width,
        }))}
      />
    </>
  );
};

export { CompetitionSalePointDetails };
